var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.scheduleDays),function(day){return _c('div',[_c('h5',[_c('router-link',{attrs:{"to":'/schedule/daily/' + day.day}},[_vm._v("\n\t\t\t"+_vm._s(day.dayPretty)+"\n\t\t")])],1),_c('table-list',{attrs:{"record-name":"Event","records":day.events,"hide-record-count":true,"fields":[
				{label: 'Employee', key: 'employeeName'},
				{label: 'Start', key: 'startTime'},
				{label: 'End', key: 'endTime'},
				{label: 'Role', key: 'role'}
			]}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }